export const insuranceReportTrackingIds = {
  tableColumnsFilterBtn: 'nwx-insurance-report:table-columns-filter-btn',
  printReportDataTrackingId: 'nwx-insurance-report:print',
  saveToPMSTrackingId: 'nwx-insurance-report:eligibility-new-report-save-to-pms-btn',
  inNetworkFilterSwitchOptionBtn: 'nwx-insurance-report:eligibility-report-in-network-filter-switch-option',
  outOfNetworkFilterSwitchOptionBtn: 'nwx-insurance-report:eligibility-report-out-of-network-filter-switch-option',
  searchFieldTrackingId: 'nwx-insurance-report:eligibility-report-search-field',
  writebackModalSaveToPMSBtn: 'nwx-insurance-report:writeback-modal:eligibility-report-save-to-pms-btn',
  writebackModalCancelBtn: 'nwx-insurance-report:writeback-modal:eligibility-report-cancel-btn',
  writebackModalStepperSaveToPMSBtn:
    'nwx-insurance-report:writeback-modal:stepper:eligibility-report-print-btn-in-error-stepper',
  writebackModalStepperPrintBtnInErrorStep:
    'nwx-insurance-report:writeback-modal:eligibility-report-print-btn-in-error-stepper-next-btn',
  writebackModalClickHereLink: 'nwx-insurance-report:writeback-modal:eligibility-report-help-article-btn-link',
  writebackModalStepperHelpArticleLinkBtn:
    'nwx-insurance-report:writeback-modal:stepper:eligibility-report-help-article-btn-link',
  writebackModalStepperCloseBtnInErrorStep:
    'nwx-insurance-report:writeback-modal:eligibility-report-close-btn-error-stepper',
  writebackModalStepperNextBtn: 'nwx-insurance-report:writeback-modal:eligibility-report-stepper-next-btn',
};
